import { useEffect, useState, useCallback } from "react";

/**
 * Detects when the user types a target word anywhere on the page.
 * Returns the trigger state + a reset function.
 */
export default function useTypedSequence(target, onTrigger) {
  const [buffer, setBuffer] = useState("");

  const handler = useCallback(
    (e) => {
      // Ignore when typing into a form field
      const tag = (e.target?.tagName || "").toLowerCase();
      if (["input", "textarea", "select"].includes(tag) || e.target?.isContentEditable) return;
      if (!e.key || e.key.length !== 1) return;

      setBuffer((prev) => {
        const next = (prev + e.key).toLowerCase().slice(-target.length);
        if (next === target.toLowerCase()) {
          onTrigger?.();
          return "";
        }
        return next;
      });
    },
    [target, onTrigger]
  );

  useEffect(() => {
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [handler]);
}
